import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { useFlags, useFlagsLoaded } from '@/contexts/Flags';
import { FeatureFlagsParsed } from '@/contexts/Flags/featureFlags.types';
import { resolveRemoteConfig } from '@/utils/resolveRemoteConfig';

interface FlagRouteProps {
    flag: keyof FeatureFlagsParsed;
}

const FlagRoute: React.FC<FlagRouteProps> = ({ flag }) => {
    const flags = useFlags();
    const isLoaded = useFlagsLoaded();

    if (!isLoaded) {
        return null;
    }

    if (
        !resolveRemoteConfig(
            flags[flag] as Parameters<typeof resolveRemoteConfig>[0],
        )
    ) {
        return <Navigate to="/" replace />;
    }

    return <Outlet />;
};

export default FlagRoute;
